import React, { Component } from "react";
import AppContext from "../../../contexts/AppContext";
import { deleteAccount } from "../../../services/userDatails";

class DeleteModal extends Component {
    state = {
        confirm_del_text : "",
    }
    handleInputChange = e => {
        this.setState({ confirm_del_text: e.target.value });
    };
    delete = () => {
        if(this.state.confirm_del_text !== 'DELETE ACCOUNT')
        {
            this.context.state.showCodeMessage(
                "Incorrect text. Please try again.",
                "error"
            );
        }else{
            deleteAccount()
                .then(res => {
                    this.props.hideDelete();
                    this.context.state.logOut();
                })
                .catch(error => {
                    this.context.state.handelError(error);
                });
        }
        
    };

    render() {
        return (
            <div className="model-container model-center model-backdrop-show">
			    <button onClick={this.props.hideDelete} type="button" className="modal-close" data-dismiss="modal" aria-hidden="true"><img src="/images/close.svg" alt="close"/></button>
                <div
                    aria-labelledby="model-title"
                    aria-describedby="model-content"
                    className="model-popup model-modal model-show"
                    role="dialog"
                    aria-live="assertive"
                    aria-modal="true"
                >
                    {/*<div className="model-header">
					    <img src="/images/deleteAccountModal.png" alt=""></img>
                    </div>*/}
                    <h2 className="model-title" id="model-title">
                        Delete account
                    </h2>
                    <div className="model-content">
                        <div
                            id="model-content"
                            className=" text-left model-html-container"
                        >
                            <strong> Please Note </strong>: Deleting your
                            account will cancel any open Memberships as well as
                            remove all data from ProWriter including your writer
                            portfolio, clients, and messages history
							<p className="mt-3 mb-3">To confirm deletion of your account type <strong> DELETE ACCOUNT </strong> in the field below and submit.</p>
							<input type="text" onChange={this.handleInputChange} className="form-control w-50 m-auto d-block"/>
                        </div>
                        <div
                            className="model-validation-message"
                            id="model-validation-message"
                        ></div>
                    </div>
                    <div className="model-actions">
                        <button
                            type="button"
                            className="btn btn-danger"
                            onClick={this.delete}
                        >
                            Confirm Deletion
                        </button>
                        <button
                            type="button"
                            onClick={this.props.hideDelete}
                            className="btn btn-default"
                        >
                            Close
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}
DeleteModal.contextType = AppContext;
export default DeleteModal;



// WEBPACK FOOTER //
// ./src/components/writer/settings/DeleteModal.js